import styled from "@emotion/styled";
import { Apps } from "@mui/icons-material";
import { Menu } from "@mui/material";
import { Image } from "Components";
import { Row } from "antd";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest, ResponseDataType } from "api"; // Import API utility
import { useAppContext } from "Context/AppContext";

const serviceList = [
  {
    icon: "/Images/hr-service-icon.png",
    name: "Nhân sự",
    url: "/member-list",
  },
  // {
  //   icon: "/Images/docs-service-icon.png",
  //   name: "Tài liệu",
  //   url: "",
  // },
];

// Định nghĩa interface cho dữ liệu tổ chức
interface OrgListDto {
  orgId?: string;
  orgList: OrganizationInfo[];
  memberId?: string;
}

interface OrganizationInfo {
  id: string;
  name: string;
  logo: string;
  numberOfMembers: number;
  memberAvatar: string;
  memberId: string;
  memberDepartmentCode: string;
}

export const ServiceDropdown = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [hasOrg, setHasOrg] = useState<boolean | null>(null); // State để kiểm tra tổ chức
  const open = Boolean(anchorEl);

  const { showNoteApp } = useAppContext();

  // Hàm lấy danh sách tổ chức
  const getOrgList = async () => {
    try {
      const response: ResponseDataType<OrgListDto> = await getRequest(
        `/customer/get-org-list?${
          localStorage.getItem("customerId")
            ? `&customerId=${localStorage.getItem("customerId")}`
            : ""
        }${
          localStorage.getItem("organizationId")
            ? `&orgId=${localStorage.getItem("organizationId")}`
            : ""
        }`
      );

      if (response.code) {
        toast.error(response.message);
        setHasOrg(false);
        return;
      }

      // Kiểm tra orgList có rỗng hay không
      const orgList = response.data?.orgList || [];
      setHasOrg(orgList.length > 0);

      // Lưu organizationId nếu có
      if (response.data?.orgId) {
        localStorage.setItem("organizationId", response.data.orgId);
      }
    } catch (error) {
      console.error("Error fetching organization list:", error);
      setHasOrg(false);
      toast.error("Không thể kiểm tra tổ chức. Vui lòng thử lại.");
    }
  };

  // Gọi API khi component mount
  useEffect(() => {
    getOrgList();
  }, []);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClick = (
    event: React.MouseEvent<HTMLImageElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleServiceClick = (service: { name: string; url: string }) => {
    if (service.name === "Nhân sự" && hasOrg === false) {
      toast.error("Bạn chưa có tổ chức.");
      handleCloseMenu();
      return;
    }
    // Nếu có tổ chức hoặc không phải mục "Nhân sự", tiếp tục điều hướng
    handleCloseMenu();
  };

  return (
    <div>
      <div
        id="service-dropdown"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Apps sx={{ cursor: "pointer", fontSize: "30px" }} />
      </div>
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        autoFocus={false}
        MenuListProps={{
          "aria-labelledby": "service-dropdown",
        }}
        PaperProps={{
          sx: {
            right: showNoteApp ? 400 : 120,
            left: "auto !important",
            borderRadius: "10px",
            padding: 3,
            marginTop: "10px",
            boxShadow: "none",
            border: "solid 1px #cacaca",
          },
        }}
      >
        <Row>
          {serviceList.map((service, index) => (
            <ServiceItemWrapper
              key={index}
              onClick={() => handleServiceClick(service)}
              to={
                hasOrg === false && service.name === "Nhân sự"
                  ? "#"
                  : service.url
              } // Ngăn điều hướng nếu chưa có tổ chức
              style={{ marginLeft: index ? 30 : 0 }}
            >
              <Image
                style={{ width: 50, height: 50 }}
                defaultSrc={service.icon}
              />
              <div style={{ marginTop: 10, fontSize: 18, fontWeight: 600 }}>
                {service.name}
              </div>
            </ServiceItemWrapper>
          ))}
        </Row>
      </Menu>
    </div>
  );
};

const ServiceItemWrapper = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: black;

  &:hover {
    color: rgb(0, 0, 0);
  }
`;
